var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_20",
    "data-name": "Artboard \\u2013 20",
    clipPath: "url(#clip-Artboard_20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-times-circle",
    "data-name": "Icon awesome-times-circle",
    d: "M13.063.563a12.5,12.5,0,1,0,12.5,12.5A12.5,12.5,0,0,0,13.063.563Zm6.129,15.781a.605.605,0,0,1,0,.857l-2,1.991a.605.605,0,0,1-.857,0l-3.276-3.306L9.781,19.192a.605.605,0,0,1-.857,0l-1.991-2a.605.605,0,0,1,0-.857l3.306-3.276L6.933,9.781a.605.605,0,0,1,0-.857l2-2a.605.605,0,0,1,.857,0l3.276,3.311,3.281-3.306a.605.605,0,0,1,.857,0l2,2a.605.605,0,0,1,0,.857l-3.311,3.276Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#f80749"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/iconCross.e4f522e50fb367402abfdcda842382ed.svg";
export { ForwardRef as ReactComponent };